class ReacueReason{
    
    constructor(){
        this.reacueReason = [
            { id: 0, name: "不明原因創傷" }
            , { id: 1, name: "不明原因精神、行動異常、虛弱消瘦" }
            , { id: 2, name: "人為干擾（工程、除草、拆除）" }
            , { id: 3, name: "落巢、失親幼獸" }
            , { id: 4, name: "窗擊or高度懷疑窗擊" }
            , { id: 5, name: "路殺or高度懷疑路殺" }
            , { id: 6, name: "中毒or高度懷疑中毒" }
            , { id: 7, name: "各式陷阱（網具、黏鼠板、溝渠等）" }
            , { id: 8, name: "動物攻擊or懷疑動物攻擊" }
            , { id: 9, name: "人類攻擊、捕捉誤傷" }
            , { id: 10, name: "闖入建築物" }
            , { id: 11, name: "查緝沒入（私養、虐待）" }
            , { id: 12, name: "疾病" }
            , { id: 13, name: "其他創傷（ex. 電擊、槍傷等）" }
            , { id: 14, name: "天災（颱風、豪雨、野火）" }
            , { id: 15, name: "健康個體誤撿" }
            , { id: 16, name: "其他" }
            , { id: 17, name: "人類攻擊、捕捉誤傷" }
            , { id: 18, name: "不詳（無法取得紀錄）" }
        ]
    }

    getReacueReasonItem(id){
        const item = this.reacueReason.find(item=>item.id == id )
        return item ? item.name : ""
    }

    getReacueReason(){
        return this.reacueReason;
    }

}

export default ReacueReason;